<div *ngIf="show" class="modal-overlay" (click)="closeModal()">
  <div class="modal-content large-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Create Team from Individual Registrations</h2>
      <button class="close-btn" (click)="closeModal()">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <div *ngIf="errorMessage" class="alert alert-error">{{errorMessage}}</div>

      <!-- Team Information -->
      <div class="form-section">
        <h3>Team Information</h3>
        <div class="form-grid">
          <div class="form-group">
            <label for="teamName">Team Name *</label>
            <input type="text" id="teamName" [(ngModel)]="teamName" required>
          </div>
          <div class="form-group">
            <label for="jerseyColor">Jersey Color</label>
            <input type="text" id="jerseyColor" [(ngModel)]="jerseyColor">
          </div>
          <div class="form-group">
            <label for="nearestBranch">Nearest Branch</label>
            <select id="nearestBranch" [(ngModel)]="nearestBranch">
              <option value="">Select Branch</option>
              <option *ngFor="let branch of branches" [value]="branch.name">{{branch.name}}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Team Size Indicator -->
      <div class="team-size-indicator" [class.valid]="totalPlayers > 0">
        <span class="size-label">Team Size:</span>
        <span class="size-count">{{totalPlayers}} player{{totalPlayers !== 1 ? 's' : ''}}</span>
        <span *ngIf="totalPlayers === 0" class="size-hint">You can add players now or later</span>
      </div>

      <!-- Select from Available Individuals -->
      <div class="form-section">
        <div class="section-header">
          <h3>Select Team Members ({{selectedIndividuals.size}} selected)</h3>
          <div class="section-actions">
            <button type="button" class="btn btn-secondary btn-sm" (click)="selectAllUnassigned()">
              Select All Unassigned
            </button>
            <button type="button" class="btn btn-secondary btn-sm" (click)="clearSelection()">
              Clear Selection
            </button>
          </div>
        </div>

        <!-- Search and Filter -->
        <div class="filter-controls">
          <input
            type="text"
            class="search-input"
            placeholder="Search by name, phone, or skill level..."
            [(ngModel)]="searchQuery"
          >
          <select [(ngModel)]="filterAssigned" class="filter-select">
            <option value="all">All Individuals</option>
            <option value="unassigned">Unassigned Only</option>
            <option value="assigned">Assigned Only</option>
          </select>
        </div>

        <!-- Individuals Table -->
        <div class="individuals-table-container">
          <div *ngIf="isLoading" class="loading-state">Loading individuals...</div>

          <table class="individuals-table" *ngIf="!isLoading">
            <thead>
              <tr>
                <th width="40"></th>
                <th>Name</th>
                <th>Age</th>
                <th>Gender</th>
                <th>Skill Level</th>
                <th>Phone</th>
                <th>Status</th>
                <th>Captain</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let individual of filteredIndividuals"
                [class.selected]="selectedIndividuals.has(individual.id)"
                [class.assigned]="individual.isAssigned"
              >
                <td>
                  <input
                    type="checkbox"
                    [checked]="selectedIndividuals.has(individual.id)"
                    (change)="toggleIndividual(individual.id)"
                    [disabled]="individual.isAssigned"
                  >
                </td>
                <td>
                  <div class="player-name">{{individual.fullName}}</div>
                  <div class="player-sub">By: {{individual.registeredBy}}</div>
                </td>
                <td>{{individual.age}} yrs</td>
                <td>{{individual.gender || 'N/A'}}</td>
                <td>{{individual.skillLevel || 'N/A'}}</td>
                <td>{{individual.phoneNumber || 'N/A'}}</td>
                <td>
                  <span class="status-badge" [class.assigned-badge]="individual.isAssigned">
                    {{individual.isAssigned ? 'Assigned' : 'Available'}}
                  </span>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn-captain"
                    [class.active]="captainId === individual.id"
                    [disabled]="!selectedIndividuals.has(individual.id)"
                    (click)="captainId = individual.id"
                  >
                    {{captainId === individual.id ? '★ Captain' : 'Set Captain'}}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Add New Members -->
      <div class="form-section">
        <div class="section-header">
          <h3>Add New Members ({{newMembers.length}})</h3>
          <button type="button" class="btn btn-secondary btn-sm" (click)="addNewMember()">
            + Add New Member
          </button>
        </div>

        <div *ngFor="let member of newMembers; let i = index" class="new-member-form">
          <div class="member-header">
            <h4>New Member {{i + 1}}</h4>
            <button type="button" class="btn-danger-sm" (click)="removeNewMember(i)">Remove</button>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Full Name *</label>
              <input type="text" [(ngModel)]="member.fullName" required>
            </div>
            <div class="form-group">
              <label>Gender</label>
              <select [(ngModel)]="member.gender">
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
            <div class="form-group">
              <label>Date of Birth *</label>
              <input type="date" [(ngModel)]="member.dateOfBirth" required>
            </div>
            <div class="form-group">
              <label>Skill Level *</label>
              <input type="text" [(ngModel)]="member.skillLevel" required>
            </div>
            <div class="form-group">
              <label>Phone Number *</label>
              <input type="tel" [(ngModel)]="member.phoneNumber" required>
            </div>
            <div class="form-group">
              <label>Preferred Position</label>
              <input type="text" [(ngModel)]="member.preferredPosition">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeModal()" [disabled]="isSubmitting">
        Cancel
      </button>
      <button class="btn btn-primary" (click)="submitTeam()" [disabled]="!canSubmit">
        {{isSubmitting ? 'Creating Team...' : 'Create Team'}}
      </button>
    </div>
  </div>
</div>
